import { api } from './api';

export interface JobVisibilityRoleDto {
  roleId: string;
  roleCode: string;
  roleName: string;
  roleColor: string;
  roleLabelColor: string;
}

export interface JobVisibilityConfigDto {
  id: string;
  jobTypeName: string;
  displayName: string;
  isVisible: boolean;
  roles: JobVisibilityRoleDto[];
}

export interface UpdateJobVisibilityRequest {
  isVisible: boolean;
}

export interface CreateJobVisibilityRequest {
  jobTypeName: string;
  isVisible: boolean;
  roleIds: string[];
}

export interface AvailableJobType {
  typeName: string;
  displayName: string;
}

class JobVisibilityService {
  async getAll(): Promise<JobVisibilityConfigDto[]> {
    const response = await api.get<JobVisibilityConfigDto[]>('/job-visibility');
    return response.data;
  }

  async update(id: string, request: UpdateJobVisibilityRequest): Promise<JobVisibilityConfigDto> {
    const response = await api.put<JobVisibilityConfigDto>(`/job-visibility/${id}`, request);
    return response.data;
  }

  async toggleRole(id: string, roleId: string): Promise<JobVisibilityConfigDto> {
    const response = await api.post<JobVisibilityConfigDto>(`/job-visibility/${id}/roles/${roleId}`);
    return response.data;
  }

  async create(request: CreateJobVisibilityRequest): Promise<JobVisibilityConfigDto> {
    const response = await api.post<JobVisibilityConfigDto>('/job-visibility', request);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/job-visibility/${id}`);
  }

  async getAvailableTypes(): Promise<AvailableJobType[]> {
    const response = await api.get<AvailableJobType[]>('/job-visibility/available-types');
    return response.data;
  }
}

export const jobVisibilityService = new JobVisibilityService();
